// 获取某个切片
export const getFileChunk = (file, chunkSize = 1024 * 500, index) => {

    let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice

    let start = index * chunkSize
    let end = (start + chunkSize) >= file.size ? file.size : start + chunkSize

    return {
        chunk: blobSlice.call(file, start, end),
        size: end - start
    }
}
